import { render, staticRenderFns } from "./EngagementRewards.vue?vue&type=template&id=0d574668"
import script from "./EngagementRewards.vue?vue&type=script&lang=ts"
export * from "./EngagementRewards.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports